'use client'

import { useTranslations } from 'next-intl'
import {
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { popModal } from '@/components/modals'

interface EmbedConfirmationModalProps {
  onConfirm: () => void
  onCancel?: () => void
}

export default function EmbedConfirmationModal({
  onConfirm,
  onCancel,
}: EmbedConfirmationModalProps) {
  const t = useTranslations('publish-modal.embed_confirmation')

  const handleConfirm = () => {
    onConfirm()
    popModal()
  }

  const handleCancel = () => {
    onCancel?.()
    popModal()
  }

  return (
    <DialogContent
      className="sm:max-w-[425px] bg-gradient-to-br from-[#222222]/95 via-[#2B2B2B] to-[#010101]/95 backdrop-blur-lg border-white/10 z-[80]"
      overlayClassName="z-[80]"
    >
      <DialogHeader>
        <DialogTitle className="text-xl font-semibold text-white">
          {t('title')}
        </DialogTitle>
        <DialogDescription className="text-white/80 text-sm">
          {t('message')}
        </DialogDescription>
      </DialogHeader>
      <DialogFooter className="mt-6 gap-2 sm:gap-0">
        <Button
          type="button"
          variant="ghost"
          onClick={handleCancel}
          className="px-4 py-2 text-white/80 hover:text-white transition-colors hover:bg-white/10 rounded-md"
        >
          {t('cancel')}
        </Button>
        <Button
          type="button"
          onClick={handleConfirm}
          className="px-6 py-2 bg-white text-black font-medium rounded-md hover:bg-white/90 transition-colors"
        >
          {t('confirm')}
        </Button>
      </DialogFooter>
    </DialogContent>
  )
}
